import { render, staticRenderFns } from "./modify_password.vue?vue&type=template&id=125cb48e&scoped=true"
import script from "./modify_password.vue?vue&type=script&lang=js"
export * from "./modify_password.vue?vue&type=script&lang=js"
import style0 from "./modify_password.vue?vue&type=style&index=0&id=125cb48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125cb48e",
  null
  
)

export default component.exports